import { useContext } from "react";
import { StatefulTabsContext, StatefulTabsContextI } from "../context/TabsModalContext";

export default function useStatefulTabs<T>(): StatefulTabsContextI<T> {
    return useContext(StatefulTabsContext) as StatefulTabsContextI<T>;
}
